import React, {useState, useEffect}					from 'react';

import Input										from '../ressources/components/Input';
import DocumentItem									from '../ressources/components/Document';
import Load											from '../ressources/components/Load/Load';
import Modal										from '../ressources/components/Modal';

import {useAppSelector, useAppDispatch}				from '../app/hooks';
import {closeUpload, pushUpload,
	setUploadPercent}								from '../redux/documents/documents';
import {Device}										from '../redux/devices/interface';
import {Funder} 									from '../redux/contracts/interface';
import {Document} 									from '../redux/documents/interface';

import {ft_genNotification, ft_pushNotification}	from '../ressources/functions/notification';
import {ft_getDocumentCreator}						from '../ressources/functions/document';

import img_upload									from '../ressources/images/icon/upload.svg';
import img_trash									from '../ressources/images/icon/trash.svg';

import LANGUAGE										from '../ressources/language';
import * as API										from '../ressources/API';

import './Devices.css';

interface Props {
	editData?: Device,
	editDataFunder?: Funder | undefined,
	documents?: File[],
	setDocument?: (docuements: File[]) => void
}

function DevicesDocumentsMenu(props: Props) {
	const dispatch = useAppDispatch();
	const user = useAppSelector(state => state.user.data);
	const users = useAppSelector(state => state.companyUsers.data);
	const uploadDocuments = useAppSelector(state => state.documents.uploadDocument);
	const lang = useAppSelector(state => state.settings.lang);
	const idNotification = useAppSelector(state => state.notifications.lastId);

	const [deviceDocuments, set_deviceDocuments] = useState<Document[]>([]);
	const [modal, set_modal] = useState<null | {isContract: boolean, url: string, document: Document}>(null);
	const [load, set_load] = useState(false);

	const TEXTE = LANGUAGE(lang);

	let foundDocument = false;

	useEffect(() => {
		if (!props.editData)
			return;

		set_deviceDocuments([]);
		set_load(true);
		getDeviceDocuments();
	}, [props.editData?._id]);

	function getDeviceDocuments() {
		if (!props.editData)
			return;

		API.getDeviceDocuments(props.editData._id, user)
		.then((response) => {
			set_load(false);
			if (response && response.status)
				set_deviceDocuments(response.data);
		});
	}

	function uploadFile(file: FileList | null) {
		if (!file || !file[0] || (!props.editData && !props.setDocument))
			return;

		if (props.setDocument && props.documents)
			props.setDocument([...props.documents, file[0]]);

		if (!props.editData)
			return;

		let error = null;

		if (file[0].size > 2097152)
			error = TEXTE.global.fileToBig;

		const index = uploadDocuments.length;

		const dispatchData = {
			index,
			dispatch,
			function: setUploadPercent
		};

		const uploadFileData = {
			percent:  error || 0,
			filename: file[0].name,
			size:     file[0].size,
			id:       props.editData._id
		};

		dispatch(pushUpload(uploadFileData));

		if (!error) {
			API.uploadDeviceDocument(props.editData._id, file[0], user, dispatchData)
			.then((response) => {
				if (!response || !response.status)
					return dispatch(setUploadPercent({index, percent: `error: ${response?.error || ''}`}));

				const notification = ft_genNotification(TEXTE, 'fileDownloadDone', img_upload, props.editData?.name);

				ft_pushNotification(dispatch, idNotification, notification);
				getDeviceDocuments();
			});
		}
	}

	function renderContract() {
		if (!props.editDataFunder?.file)
			return <></>;

		const onClick = async (isDownload: boolean) => {
			if (!props.editData?.contract || !props.editDataFunder)
				return;

			const url = await API.downloadContract(props.editData.contract, props.editDataFunder.file, user, !isDownload);

			if (isDownload)
				return;
			set_modal({
				isContract: true,
				url:        url as string,
				document:   props.editDataFunder.file
			});
		};

		foundDocument = true;

		return (
			<DocumentItem
				isValala
				onClick={() => onClick(false)}
				onClickDownload={() => onClick(true)}
				size={props.editDataFunder.file.size}
				filename={props.editDataFunder.file.name}
				creator={ft_getDocumentCreator(props.editDataFunder.file, users)}
			/>
		);
	}

	function renderDevicesDocuments() {
		const render: React.ReactElement[] = [];

		deviceDocuments.forEach((document) => {
			const onClickDelete = () => {
				if (!props.editData)
					return;

				API.deleteDeviceDocument(props.editData._id, document, user)
				.then((response) => {
					const notification = ft_genNotification(TEXTE, (!response || !response.status) ? 'error' : 'editSuccess', img_trash, response.error, (!response || !response.status) ? 'error' : 'success');

					ft_pushNotification(dispatch, idNotification, notification);
					getDeviceDocuments();
				});
			};

			foundDocument = true;
			render.push(
				<DocumentItem
					size={document.size}
					filename={document.name}
					isValala={document.isValala}
					onClickDelete={onClickDelete}
					creator={ft_getDocumentCreator(document, users)}
					onClick={async () => {
						if (!props.editData)
							return;

						const url = await API.downloadDeviceDocument(props.editData._id, document, user, true);

						set_modal({url: url as string, document, isContract: false});
					}}
					onClickDownload={() => props.editData && API.downloadDeviceDocument(props.editData._id, document, user)}
				/>
			);
		});

		props.documents?.forEach((file, i) => {
			foundDocument = true;
			render.push(
				<DocumentItem
					size={file.size}
					filename={file.name}
					percent={file.size > 2097152 ? TEXTE.global.fileToBig : ' '}
					onClickDelete={() => {
						if (!props.documents || !props.setDocument)
							return;
						const copy: File[] = [...props.documents];

						copy.splice(i, 1);
						props.setDocument(copy);
					}}
				/>
			);
		});

		return render;
	}

	function renderUploadDocuments() {
		const render: React.ReactElement[] = [];

		uploadDocuments.forEach((uploadData, index) => {
			if (uploadData.isClose || uploadData.id !== props.editData?._id || uploadData.percent as number === 100)
				return;
			render.push(
				<DocumentItem
					size={uploadData.size}
					percent={uploadData.percent}
					filename={uploadData.filename}
					onClickDelete={() => dispatch(closeUpload(index))}
				/>
			);
		});

		return render;
	}

	return (
		<div className={'deviceDocumentsContainer'}>
			<span className={'deviceDocumentsTitle'}>{TEXTE.devices.deviceDocuments}</span>
			{renderContract()}
			{renderDevicesDocuments()}

			{load && <Load center />}
			{(!load && !foundDocument) && <DocumentItem />}

			<span className={'deviceDocumentsTitle'}>{TEXTE.devices.downloadDocuments}</span>
			<Input
				type={'file'}
				onChangeFile={uploadFile}
				fileInputText={TEXTE.devices.deviceDocumentRules}
				accept={'gif,.jpg,.jpeg,.tiff,.png,.webp,.bmp,.pdf'}
			/>
			{renderUploadDocuments()}

			{modal &&
				<Modal
					fullWidth
					onClose={() => set_modal(null)}
					confirmButtonText={TEXTE.global.download}
					confirmButton={() => {
						if (modal.isContract && props.editData?.contract)
							return API.downloadContract(props.editData.contract, modal.document, user);
						else if (!modal.isContract && props.editData)
							API.downloadDeviceDocument(props.editData._id, modal.document, user);
					}}
				>
					<embed src={modal.url} style={{width: '100%', height: '90vh'}} />
				</Modal>
			}
		</div>
	);
}

export default DevicesDocumentsMenu;
